import { render, staticRenderFns } from "./ebc-dialog.vue?vue&type=template&id=6550fede&scoped=true"
import script from "./ebc-dialog.vue?vue&type=script&lang=js"
export * from "./ebc-dialog.vue?vue&type=script&lang=js"
import style0 from "./ebc-dialog.vue?vue&type=style&index=0&id=6550fede&prod&lang=scss"
import style1 from "./ebc-dialog.vue?vue&type=style&index=1&id=6550fede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550fede",
  null
  
)

export default component.exports